






import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class Alert extends Vue {
  @Getter("locked") readonly locked!: boolean;
}
